import { render, staticRenderFns } from "./AddClockModal.vue?vue&type=template&id=9b452c1c&scoped=true&"
import script from "./AddClockModal.vue?vue&type=script&lang=js&"
export * from "./AddClockModal.vue?vue&type=script&lang=js&"
import style0 from "./AddClockModal.vue?vue&type=style&index=0&id=9b452c1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b452c1c",
  null
  
)

export default component.exports